import store from '@/store/'
import axios from 'axios'
import Vue from 'vue'

export const loginPollingMixin = {
  data() {
    return {
      pingLoginUrl: '/users/pingLogin',
      pollingTimer: null,      // 定时器句柄
      isPolling: false,        // 是否正在请求中（防止并发）
      checkInterval: 60000,    // 正常轮询间隔：30秒
      hiddenCheckInterval: 10000, // 后台隐藏时的轮询间隔：5秒
      logoutFun: null,
    };
  },

  methods: {
    /**
     * 执行单次状态检查
     */
    async doCheckLoginStatus() {
      // if(!this.userName || !this.userTimestemp || this.userType == null) return;
      let baseurl = Vue.prototype.baseurl;//main.js中
      let projectName = Vue.prototype.projectName;//main.js中
      if (this.isPolling) return; // 防止并发
      // console.log('xxxxxxxxxxxxxxxxxxx', baseurl, projectName);
      if (!store.state.userInfo) return;
      let username;
      let userrole = store.state.userInfo.role;
      let timestemp = store.state.websocketTimestemp;
      if (store.state.userInfo.role == 1) {
        username = store.state.userInfo.userName;
      } else if (store.state.userInfo.role == 2) {
        username = store.state.userInfo.loginAccount;
      } else { 
        return;
      }
      if (!username) return;
      this.isPolling = true;
      try {
        // 替换为你的实际接口，例如 this.$axios.get('/api/check_token')
        const res = await axios.get(baseurl + projectName + "/front" + this.pingLoginUrl, { params: { username: username, timestemp: timestemp, userrole: userrole } })
        // const res = await axios.get(Vue.prototype.baseurl + Vue.prototype.projectName + "/front" + this.pingLoginUrl, { params: { username: store.state.userInfo.loginAccount, timestemp: store.state.websocketTimestemp } })
        // const res = await getAction(this.pingLoginUrl, { username: store.state.userInfo.loginAccount, timestemp: store.state.websocketTimestemp } )
        // const res = await service({ url: this.pingLoginUrl, method: 'get', data: { username: store.state.userInfo.loginAccount, timestemp: store.state.websocketTimestemp } } )
        if (!res.data.success) {

          this.$message({
            showClose: true,
            type: 'warning',
            duration: 5000,
            message: res.data.message || '检测到登录状态异常，强制退出',
          });
          
          console.warn('检测到登录状态异常，强制退出');
          this.stopLoginPolling();
          // 执行登出逻辑，如清除本地 Token、跳转登录页等
          // this.$store.dispatch('user/logout');
          this.logoutFun && this.logoutFun()
        }
      } catch (error) {
        console.error('登录状态检查失败:', error);
      } finally {
        this.isPolling = false;
        this.scheduleNextCheck(); // 无论成功失败，安排下一次检查
      }
    },

    /**
     * 根据页面可见性安排下一次检查
     */
    scheduleNextCheck() {
      clearTimeout(this.pollingTimer); // 清除旧定时器

      // 判断当前页面是否可见
      const isVisible = document.visibilityState === 'visible';
      const delay = isVisible ? this.checkInterval : this.hiddenCheckInterval;

      this.pollingTimer = setTimeout(() => {
        this.doCheckLoginStatus();
      }, delay);
    },

    /**
     * 处理页面可见性变化
     */
    handleVisibilityChange() {
      // 切换前后台的瞬间，立即执行一次检查，保证时效性
      this.doCheckLoginStatus();

      // 重新根据新的可见性状态计算下一次延迟
      this.scheduleNextCheck();
    },

    /**
     * 启动轮询
     */
    startLoginPolling() {
      // 绑定可见性监听器
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      // 立即执行首次检查
      this.doCheckLoginStatus();
    },

    /**
     * 停止轮询并清理资源
     */
    stopLoginPolling() {
      clearTimeout(this.pollingTimer);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  },

  mounted() {
    this.startLoginPolling();
  },

  beforeDestroy() {
    // ⚠️ Vue 2 必须在销毁前清理定时器和监听器，防止内存泄漏
    this.stopLoginPolling();
  }
};